"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var productLayouts_1 = __importDefault(require("./productLayouts"));
exports.PRODUCT_LAYOUTS = productLayouts_1.default;
var CONFIGURABLE_COMPONENTS = [
    'bottomSlot',
    'brandImage',
    'brandName',
    'powerEfficiencyFlags',
    'flags',
    'layerSlot',
    'patches',
    'productImage',
    'productName',
    'productNameNoBrand',
    'productPrice',
    'rating',
    'sellingPoints',
    'wishListButton',
];
/**
 * Object with every component as key set to 'true'. Like 'BottomSlot: true, BrandImage: true, ...'
 * Created via the CONFIGURABLE_COMPONENTS array
 */
exports.componentVisibleDefault = CONFIGURABLE_COMPONENTS.reduce(function (obj, key) {
    var _a;
    return (__assign(__assign({}, obj), (_a = {}, _a[key] = true, _a)));
}, {});
exports.productLayoutConfigDefault = {
    flexDirection: 'column',
    alignItems: 'stretch',
    patchesVisibleCount: 5,
    showCurrentPriceOnly: false,
    showMSRP: false,
    showSaving: false,
    truncateStrings: true,
    imageWrapper: {
        width: '100%',
        scaleOnExpandedVariations: 0.8,
    },
    detailsWrapper: {
        width: '100%',
        padding: '0.25rem',
    },
    descriptionWrapper: {
        slideUpOnExpandedVariations: true,
    },
    layerSlot: {
        hideOnExpandedVariations: true,
    },
    patches: {
        gridGap: 0.7,
        patchSize: 1.5,
    },
    componentVisible: __assign(__assign({}, exports.componentVisibleDefault), { sellingPoints: false, brandImage: false, productName: false }),
};
var productLayoutConfigCollection = __assign(__assign({}, productLayouts_1.default.reduce(function (obj, key) {
    var _a;
    return (__assign(__assign({}, obj), (_a = {}, _a[key] = __assign({}, exports.productLayoutConfigDefault), _a)));
}, {})), { defaultReduced: __assign(__assign({}, exports.productLayoutConfigDefault), { imageWrapper: {
            width: '100%',
            scaleOnExpandedVariations: 1,
        }, descriptionWrapper: {
            slideUpOnExpandedVariations: false,
        }, componentVisible: __assign(__assign({}, exports.componentVisibleDefault), { bottomSlot: false, brandName: false, brandImage: false, layerSlot: false, patches: false, productNameNoBrand: false, rating: false, sellingPoints: false }) }), defaultBigPicture: __assign(__assign({}, exports.productLayoutConfigDefault), { patchesVisibleCount: 7, imageWrapper: {
            width: '100%',
            scaleOnExpandedVariations: 0.85,
        }, layerSlot: {
            hideOnExpandedVariations: false,
        } }), moreInfo: __assign(__assign({}, exports.productLayoutConfigDefault), { flexDirection: 'row', alignItems: 'flex-start', patchesVisibleCount: 6, imageWrapper: {
            width: '33.33%',
            scaleOnExpandedVariations: 1,
        }, detailsWrapper: {
            width: '66.67%',
            padding: '0 0.75rem',
        }, layerSlot: {
            hideOnExpandedVariations: false,
        }, componentVisible: __assign(__assign({}, exports.componentVisibleDefault), { productName: false, brandName: false }) }), justImage: __assign(__assign({}, exports.productLayoutConfigDefault), { descriptionWrapper: {
            slideUpOnExpandedVariations: false,
        }, imageWrapper: {
            width: '100%',
            scaleOnExpandedVariations: 1,
        }, componentVisible: __assign(__assign({}, exports.componentVisibleDefault), { bottomSlot: false, brandImage: false, brandName: false, powerEfficiencyFlags: false, layerSlot: false, patches: false, productNameNoBrand: false, productName: false, productPrice: false, rating: false, sellingPoints: false }) }), justProductName: __assign(__assign({}, exports.productLayoutConfigDefault), { descriptionWrapper: {
            slideUpOnExpandedVariations: false,
        }, componentVisible: __assign(__assign({}, exports.componentVisibleDefault), { bottomSlot: false, brandName: false, powerEfficiencyFlags: false, flags: false, layerSlot: false, patches: false, productImage: false, productName: false, productPrice: false, rating: false, sellingPoints: false, wishListButton: false }) }) });
exports.default = productLayoutConfigCollection;
//# sourceMappingURL=productLayoutConfig.js.map